import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 overflow-y-auto"
};
const _hoisted_2 = {
  class: "flex min-h-full items-center justify-center p-4 sm:p-8 text-center"
};
const _hoisted_3 = {
  class: "space-y-3"
};
const _hoisted_4 = {
  for: "content",
  class: "block py-2 text-slate-800 dark:text-black"
};
const _hoisted_5 = {
  class: "text-slate-800 dark:text-black"
};
const _hoisted_6 = {
  class: "font-bold"
};
const _hoisted_7 = {
  class: "mt-6 flex justify-end space-x-3"
};
const _hoisted_8 = {
  type: "submit",
  class: "btn2 inline-flex justify-center rounded-full px-3 py-1.5 shadow-lg hover:shadow-lg bg-indigo-500 dark:bg-indigo-600 text-slate-100 hover:bg-indigo-600 dark:hover:bg-indigo-500 transition-colors duration-200"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ChatBubbleLeftRightIcon = _resolveComponent("ChatBubbleLeftRightIcon");
  const _component_TransitionChild = _resolveComponent("TransitionChild");
  const _component_DialogTitle = _resolveComponent("DialogTitle");
  const _component_StyleTextarea = _resolveComponent("StyleTextarea");
  const _component_DialogPanel = _resolveComponent("DialogPanel");
  const _component_Dialog = _resolveComponent("Dialog");
  const _component_TransitionRoot = _resolveComponent("TransitionRoot");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.openDialog && $options.openDialog(...args)),
    class: "btn flex items-center justify-center px-3 py-2 rounded-full text-white hover:bg-white hover:border-slate-300 hover:shadow-lg hover:text-indigo-500 dark:hover:bg-white dark:hover:text-white transition-colors duration-200"
  }, [_createVNode(_component_ChatBubbleLeftRightIcon, {
    class: "hidden w-5 h-5 mr-1 xl:mr-2 sm:block"
  }), _createTextVNode(" " + _toDisplayString(_ctx.$t("HeaderView.HeaderFeedback.feedback")), 1)]), _createVNode(_component_TransitionRoot, {
    appear: "",
    show: $data.isDialogOpen,
    as: "template"
  }, {
    default: _withCtx(() => [_createVNode(_component_Dialog, {
      as: "div",
      class: "relative z-10",
      open: $data.isDialogOpen,
      onClose: $options.closeDialogFromMusk
    }, {
      default: _withCtx(() => [_createVNode(_component_TransitionChild, {
        as: "template",
        enter: "duration-300 ease-out",
        "enter-from": "opacity-0",
        "enter-to": "opacity-100",
        leave: "duration-200 ease-in",
        "leave-from": "opacity-100",
        "leave-to": "opacity-0"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("div", {
          class: "fixed inset-0 bg-black/25"
        }, null, -1)])),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_TransitionChild, {
        as: "template",
        enter: "duration-300 ease-out",
        "enter-from": "opacity-0 scale-95",
        "enter-to": "opacity-100 scale-100",
        leave: "duration-200 ease-in",
        "leave-from": "opacity-100 scale-100",
        "leave-to": "opacity-0 scale-95"
      }, {
        default: _withCtx(() => [_createVNode(_component_DialogPanel, {
          style: {
            "background": "#F6F9FB"
          },
          class: "w-full max-w-4xl transform overflow-hidden rounded-lg bg-white dark:bg-white p-3 sm:p-6 text-left align-middle shadow-lg dark:shadow-gray-900 transition-all"
        }, {
          default: _withCtx(() => [_createVNode(_component_DialogTitle, {
            as: "h3",
            class: "text-xl font-medium leading-6 text-slate-800 dark:text-black"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("HeaderView.HeaderFeedback.feedback")), 1)]),
            _: 1
          }), _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.submitFeedback && $options.submitFeedback(...args), ["prevent"])),
            class: "mt-4"
          }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("HeaderView.HeaderFeedback.content")), 1), _createVNode(_component_StyleTextarea, {
            id: "content",
            modelValue: $data.form.content,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.content = $event),
            placeholder: _ctx.$t('HeaderView.HeaderFeedback.contentPlaceholder'),
            rows: "4",
            required: ""
          }, null, 8, ["modelValue", "placeholder"])]), _cache[6] || (_cache[6] = _createElementVNode("div", null, null, -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("HeaderView.HeaderFeedback.note1")), 1), _createElementVNode("button", {
            class: "btn2 px-3 rounded-full",
            onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.feedbackForm && $options.feedbackForm(...args), ["prevent"]))
          }, _toDisplayString(_ctx.$t("HeaderView.HeaderFeedback.questionnaireBtn")), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t("HeaderView.HeaderFeedback.note11")), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("HeaderView.HeaderFeedback.note2")), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t("HeaderView.HeaderFeedback.note3")), 1)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = (...args) => $options.closeDialog && $options.closeDialog(...args)),
            class: "btn3 inline-flex justify-center rounded-full px-3 py-1.5 border hover:bg-gray-50 dark:hover:bg-gray-700 shadow-lg hover:shadow-lg bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-slate-800 dark:text-slate-100"
          }, _toDisplayString(_ctx.$t("HeaderView.HeaderFeedback.cancel")), 1), _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.$t("HeaderView.HeaderFeedback.submit")), 1)])], 32)]),
          _: 1
        })]),
        _: 1
      })])])]),
      _: 1
    }, 8, ["open", "onClose"])]),
    _: 1
  }, 8, ["show"])], 64);
}